import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Check, X, CalendarClock, Inbox } from "lucide-react";
import { useTr } from "@/i18n/translator";

export default function Feed() {
  const tr = useTr();
  const [posts, setPosts] = useState([]);

  const load = () => api.get("/posts", { params: { status: "pending" } }).then(({ data }) => setPosts(data));
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    await api.patch(`/posts/${id}/status`, { status: "scheduled" });
    toast.success("Programado");
    load();
  };
  const reject = async (id) => {
    await api.patch(`/posts/${id}/status`, { status: "rejected" });
    toast.success("Rechazado");
    load();
  };

  return (
    <div className="space-y-6" data-testid="feed-page">
      <div>
        <div className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("BANDEJA · APROBACIÓN")}</div>
        <h1 className="font-display text-4xl sm:text-5xl mt-2">{tr("Feed pendiente")}</h1>
      </div>

      {posts.length === 0 ? (
        <div className="bg-white border border-dashed border-[#0A0A0A] p-10 text-center">
          <Inbox className="w-8 h-8 mx-auto text-[#5C5C5C]" />
          <div className="font-mono-mark text-[10px] text-[#5C5C5C] mt-3">{tr("BANDEJA VACÍA")}</div>
          <div className="text-sm mt-1">{tr("No hay posts pendientes de aprobación.")}</div>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {posts.map((p) => (
            <div key={p.id} className="bg-white border border-[#0A0A0A] p-5" data-testid={`feed-card-${p.id}`}>
              <div className="flex items-center justify-between border-b border-[#0A0A0A] pb-3 mb-3">
                <span className="font-mono-mark text-[10px] text-[#E53935]">{p.network.toUpperCase()}</span>
                <span className="font-mono-data text-xs text-[#5C5C5C]">{p.scheduled_at ? new Date(p.scheduled_at).toLocaleString("es-MX") : "—"}</span>
              </div>
              {p.image_base64 && (
                <img src={`data:image/png;base64,${p.image_base64}`} alt="" className="w-full aspect-video object-cover border border-[#0A0A0A] mb-3" />
              )}
              <p className="text-sm whitespace-pre-wrap">{p.body}</p>
              <div className="flex gap-2 mt-4 pt-4 border-t border-[#0A0A0A]">
                <button onClick={() => approve(p.id)} className="flex-1 font-mono-mark text-[10px] bg-[#E53935] text-white px-3 py-2 border border-[#E53935] flex items-center justify-center gap-1" data-testid={`feed-approve-${p.id}`}>
                  <Check className="w-3 h-3" /> {tr("APROBAR")}
                </button>
                <button onClick={() => reject(p.id)} className="font-mono-mark text-[10px] bg-white text-[#0A0A0A] px-3 py-2 border border-[#0A0A0A] flex items-center justify-center gap-1" data-testid={`feed-reject-${p.id}`}>
                  <X className="w-3 h-3" /> {tr("RECHAZAR")}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
